export default {
      id: "icon-share-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "./icon/icons.svg#icon-share",
      toString: function () {
        return this.url;
      }
    }